import { BranchList, CompanyList, CompanyResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/organization` — as empresas do tenant e as filiais de cada uma.
 *
 * A lista alimenta o seletor de contexto do cabeçalho; a ficha (`fetchCompany`
 * /`updateCompany`) é o cadastro fiscal que a NF-e vai ler.
 */
export const fetchCompanies = async (signal) => CompanyList.parse(await request('/api/v1/organization/companies', { signal }));
export const fetchBranches = async (companyId, signal) => {
    const query = companyId === undefined ? '' : `?companyId=${encodeURIComponent(companyId)}`;
    return BranchList.parse(await request(`/api/v1/organization/branches${query}`, { signal }));
};
export const fetchCompany = async (id, signal) => CompanyResponse.parse(await request(`/api/v1/organization/companies/${id}`, { signal }));
export const updateCompany = async (id, input) => CompanyResponse.parse(await request(`/api/v1/organization/companies/${id}`, {
    method: 'PATCH',
    body: input,
}));
//# sourceMappingURL=organization.js.map